import { createSlice  } from "@reduxjs/toolkit";

const BASE_API_URLS = {
  "production": "https://app.covet.pics",
  "development": "http://localhost:3000",
  "staging": "https://covetstaging.spacesquirrel.net",
  "testing": "http://localhost:3000/testing_db"
};

const BEACONS_URL = "/api/v1/beacons";

const slice = createSlice({
  name: "url",
  initialState: {
    baseUrl: "",
    environment: "",
    baseBeaconsUrl: ""
  },
  reducers: {
    setEnvironment: (url, action) => {
      const env = action.payload;
      typeof env === "string" && Object.keys(BASE_API_URLS).includes(env)
        ? url.environment = env
        : url.environment = "production";

      url.baseUrl = BASE_API_URLS[url.environment];
      url.baseBeaconsUrl = `${BASE_API_URLS[url.environment]}${BEACONS_URL}/`;

      return url;
    },
  }
});

export const { setEnvironment } = slice.actions;
export default slice.reducer;
